(ns frontend.view.entity-viewers.modules.risk.view
  (:require
   [basic-components.attachments :as attachments-view]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.rf-app.sub :as app-sub]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.components.spinner :as spinner]
   [frontend.view.entity-viewers.activity.insider-activity :as insider-activity]
   [frontend.view.entity-viewers.components :as evc]
   [frontend.view.entity-viewers.events.editor-utils :as eu]
   [frontend.view.entity-viewers.modules.risk.event :as event]
   [frontend.view.entity-viewers.modules.risk.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.expansion-panel.view :as expansion-panel]
   [ui.components.icon.view :as icon]
   [ui.components.radix-ui.popover.view :as popover]))

(defn risk-tools
  [{:keys [entity-id]} risk]
  (let [risk-id (:db/id risk)
        risk-popover-open? @(rf/subscribe [::sub/risk-popover-open? entity-id risk-id])]
    [:<>
     (when-let [insider-group-id (:common/insider-group risk)]
       (let [insider-group (session/get-entity insider-group-id)]
         (when insider-group
           [:div
            {:class "mr-1"}
            [popover/view
             {:open?          risk-popover-open?
              :on-open-change (fn [open?]
                                (rf/dispatch [::event/toggle-risk-popover entity-id risk-id open?]))}
             [:div
              {:class "p-1 px-2  bg-info-light text-info-light-text text-xs rounded-full"
               :on-click (fn [e]
                           (rf/dispatch [::event/toggle-risk-popover entity-id risk-id (not risk-popover-open?)])
                           (fu/stop-n-prevent e))}
              (if (= :insider-group.status/public (:insider-group/status insider-group))
                (loc/tr :was-confidential)
                "Private")]
             [insider-activity/popup-view insider-group-id]]])))
     [icon/clickable
      {:on-click (fn [e]
                   (rf/dispatch [::event/open-risk entity-id risk])
                   (fu/stop-n-prevent e))}
      [:i.fal.fa-edit]]
     [icon/clickable
      {:on-click (fn [e]
                   (rf/dispatch [::event/open-risk-history entity-id risk])
                   (fu/stop-n-prevent e))}
      [:i.fal.fa-clock]]]))

(defn risk-fields-view
  [{:keys [tenant-schema tenant] :as _ctx} risk]
  (let [entity-type (:entity/type risk)
        card-fields @(rf/subscribe [::sub/risk-columns entity-type])]
    [:div
     {:class "py-3 flex flex-col gap-3 border-t border-solid border-base-light-border-paler"}
     (->>
      card-fields
      (keep
       (fn [attr]
         (let [fs (registry/get-field-schema tenant-schema attr)
               data (fu/display-data tenant-schema tenant attr fs risk)]
           (when (and (not (cu/blank-value? data))
                      (f-permissions/field-read-access? attr
                                                        :entity.type/risk-holding
                                                        nil))
             ^{:key (str "risk-field-" attr)}
             [:div
              {:class "flex flex-col gap-2"}
              [:span
               {:class "text-base-light-text-paler"}
               (loc/field-name attr fs)]
              [:div
               {:class "text-base-light-text"}
               (fu/display-data tenant-schema tenant attr fs risk)]]))))
      (doall))]))

(defn related-entities-view
  [{:keys [tenant tenant-schema] :as _ctx} risk]
  (when-let [related-entities-elems
             (->>
              related-entities/related-entities
              (map first)
              (remove eu/no-related-entities?)
              (keep
               (fn [attr]
                 (let [fs (registry/get-field-schema tenant-schema attr)
                       data (fu/display-data tenant-schema tenant attr fs risk)]
                   (when (and (not (cu/blank-value? data))
                              (f-permissions/field-read-access?
                               attr
                               :entity.type/risk-holding
                               nil))
                     ^{:key (str "risk-related-entity-" attr)}
                     [:div
                      {:class "flex flex-col gap-2"}
                      [:span
                       {:class "text-base-light-text-paler"}
                       (loc/field-name attr fs)]
                      [:div
                       {:class "text-base-light-text"}
                       (fu/display-data tenant-schema tenant attr fs risk)]]))))
              (seq))]
    [:<>
     [:div
      {:class "py-3 flex flex-col gap-3 border-t border-solid border-base-light-border-paler"}
      (doall related-entities-elems)]]))

(defn risk-attachments-view
  [risk]
  (when-let [attachments (->> risk
                              :common/attachments
                              (keep session/get-entity)
                              (remove :common/disabled?)
                              seq)]
    [:<>
     [:div
      {:class "w-full mt-3"}
      (doall
       (for [attachment attachments]
         ^{:key (str "attachment-" (:db/id attachment))}
         [attachments-view/attachment-view attachment]))]]))

(defn risk-group-view
  [{:keys [risk-expansions all-collapse-status entity-id] :as ctx}
   [risk-status typed-risks]]
  (let [risk-group-collapse-status (get risk-expansions risk-status)
        risk-status-entity (session/get-entity risk-status)
        ;;_ (js/console.log " RISK STATUS " risk-status " >> " risk-status-entity)
        risk-group-expanded? (or (= all-collapse-status :expanded)
                                 (and (not= all-collapse-status :collapsed)
                                      (= :expanded risk-group-collapse-status)))]
    [expansion-panel/view
     {:label        (loc/tr :risk-status-group
                      [(entity/display-string risk-status-entity)
                       (count typed-risks)])
      :expanded?    risk-group-expanded?
      :on-expand!   #(rf/dispatch [::event/expand-risk entity-id risk-status])
      :on-collapse! #(rf/dispatch [::event/collapse-risk entity-id risk-status])
      :opts         {:show-borders? false}}
     [:<>
      (->>
       typed-risks
       (map
        (fn [risk]
          (let [risk-id (:db/id risk)
                risk-collapse-status (get risk-expansions risk-id)
                risk-expanded? (or (= all-collapse-status :expanded)
                                   (and (not= all-collapse-status :collapsed)
                                        (= :expanded risk-collapse-status)))]
            ^{:key (str "entity-risk-" entity-id "-" risk-id " < " all-collapse-status)}
            [expansion-panel/view
             {:label        (:risk/title risk)
              :expanded?    risk-expanded?
              :on-expand!   #(rf/dispatch [::event/expand-risk entity-id risk-id])
              :on-collapse! #(rf/dispatch [::event/collapse-risk entity-id risk-id])
              :extra-tool   [risk-tools {:entity-id entity-id} risk]
              :opts         {:show-borders? true}}
             [risk-fields-view ctx risk]
             [related-entities-view ctx risk]
             [risk-attachments-view risk]])))
       (doall))]]))

(defn risks-list
  [entity-id]
  (let [risks @(rf/subscribe [::sub/risks entity-id])
        loading? @(rf/subscribe [::sub/risks-loading? entity-id])
        all-collapse-status @(rf/subscribe [::sub/all-risks-collapse-status entity-id])
        risk-expansions @(rf/subscribe [::sub/risks-collapse-statuses entity-id])
        tenant-schema @(rf/subscribe [::app-sub/tenant-schema])
        tenant @(rf/subscribe [::app-sub/tenant])
        ctx {:entity-id           entity-id
             :all-collapse-status all-collapse-status
             :risk-expansions     risk-expansions
             :tenant              tenant
             :tenant-schema       tenant-schema}
        risk-groups (->> risks
                         (group-by :risk/status))]
    (cond
      loading?
      [:div
       {:class-name "mt-3 px-2"}
       [spinner/module-loading]]
      (zero? (count risks))
      [:div
       {:class-name "mt-3 px-2"}
       (loc/tr :no-risks-recorded)]
      :else
       [:div
       {:class "py-3 px-2"}
       [:div
        {:class "flex flex-col gap-2"}
        (->>
         risk-groups
         (sort-by (fn [[risk-status-id _]]
                    (:common/ord (session/get-entity risk-status-id))))
         (map (fn [[risk-status-id _ :as args]]
                ^{:key (str "entity-risk-" entity-id "-" risk-status-id)}
                [risk-group-view ctx args]))
         (doall))]])))

(defn risk-toolbar
  [{:keys [add-new-button? entity-id]}]
  (let [visible-risks? (seq @(rf/subscribe [::sub/risks entity-id]))]
    [:div
     {:class "flex justify-between"}
     [:div
      {:class "flex gap-3"}]
     [:div
      {:class "flex flex-auto"}
      (when visible-risks?
        [icon/clickable
         {:on-click    #(rf/dispatch [::event/collapse-all-risks entity-id])
          :tooltip     (loc/tr :collapse-all)
          :style-props {:hover {:border-color "transparent"}}}
         [:i.fal.fa-compress-alt]])
      (when visible-risks?
        [icon/clickable
         {:on-click    #(rf/dispatch [::event/expand-all-risks entity-id])
          :tooltip     (loc/tr :expand-all)
          :style-props {:hover {:border-color "transparent"}}}
         [:i.fal.fa-expand-alt]])
      (when (and add-new-button?
                 (not (session/is-read-only-user?)))
        [icon/clickable
         {:on-click    #(rf/dispatch [::event/create-risk entity-id])
          :tooltip     (loc/tr :log-new-risk)
          :style-props {:hover {:border-color "transparent"}}}
         [:i.fal.fa-plus-circle.create-option__icon]])]]))

(defn risk-module-config
  [{:keys [module-label
           module-id
           view-id
           nev-entity-type
           save-collapsed-status!
           entity-id]
    :as   props}]
  (when (not (session/is-read-only-user?))
    {:module-id              module-id
     :header                 module-label
     :collapsed?             @(r/track session/get-view-config
                                       (evc/module-collapsed-path view-id module-id))
     :start-collapsed?       false
     :header-tools           [:span.flex-grow.d-flex.justify-content-end
                              [risk-toolbar props]]
     :save-module-collapsed! save-collapsed-status!
     :content                [risks-list entity-id]}))
